const state = {
    goodInfo: null
}
const mutations = {
    setGoodInfo (state: any, goodsInfo: object) {
        state.goodInfo = goodsInfo
    }
}
const actions = {
    setGoodInfo(context: any, goodsInfo: string) {
        context.commit('setGoodInfo', goodsInfo)
    },
}
export default {
    state,
    mutations,
    actions
}